// extracted by mini-css-extract-plugin
module.exports = {"eventListPopup":"_1Y-lY","eventList":"_34cxh","event":"_2Cl6u","eventChevron":"tR_DU","eventTime":"_3GX0F","eventInfo":"_32p33"};